import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useRef } from "react";

const BoxCollection = () => {
  const printRef = useRef<HTMLDivElement>(null);
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { surveyedItems } = useSelector((state: any) => state.leadSurvey);

  const collectionAddress = leadDetails?.lead?.collection_address?.[0];
  const deliveryAddress = leadDetails?.lead?.delivery_address?.[0];
  console.log("surveyedItems-19", surveyedItems);
  const materials =
    surveyedItems?.list
      ?.find((item: any) => item.name === "Materials")
      ?.items?.filter((mat: any) => Number(mat.quantity) > 0) || [];

  return (
    <Box
      ref={printRef}
      sx={{
        maxWidth: "850px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Times New Roman",
      }}
    >
      {/* TITLE */}
      {/* <Typography
        sx={{
          textAlign: "center",
          letterSpacing: "6px",
          fontWeight: 600,
          mb: 2,
        }}
      >
        BOX-COLLECTION!
      </Typography> */}

      {/* HEADER TABLE */}
      <Table
        sx={{
          border: "1px solid black",
          borderCollapse: "collapse",
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>Date:</TableCell>
            {/* <TableCell sx={cell}></TableCell> */}
            <TableCell colSpan={2} sx={cell} align="right">
              Ref: #{leadDetails?.lead?.generated_id}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>Client Name</TableCell>
            <TableCell sx={cell} colSpan={2}>
              {leadDetails?.lead?.customer_name}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>Address</TableCell>
            <TableCell sx={cell} colSpan={2}>
              {collectionAddress?.street}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>County</TableCell>
            <TableCell colSpan={2} sx={cell}>
              {collectionAddress?.county}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cell}>Postcode</TableCell>
            <TableCell colSpan={2} sx={cell}>
              {collectionAddress?.postcode}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>Telephone Number</TableCell>
            <TableCell sx={cell} colSpan={2}>
              {leadDetails?.lead?.customer_phone
                ? `${leadDetails?.lead?.customer_country_code}${leadDetails?.lead?.customer_phone}`
                : ""}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>Email Address</TableCell>
            <TableCell sx={cell} colSpan={2}>
              {leadDetails?.lead?.customer_email}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* MATERIALS */}
      <Typography
        sx={{
          textAlign: "center",
          letterSpacing: "6px",
          fontWeight: 600,
          mt: 4,
          mb: 1,
        }}
      >
        MATERIALS
      </Typography>

      <Table
        sx={{
          border: "1px solid black",
          borderCollapse: "collapse",
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell sx={{ ...cell, fontWeight: 600 }}>
              Packing Type
            </TableCell>
            <TableCell sx={{ ...cell, fontWeight: 600 }}>
              Quantity / Notes
            </TableCell>
          </TableRow>

          {materials.map((item: any, index: number) => (
            <TableRow key={index}>
              <TableCell sx={cell}>{item?.item}</TableCell>
              <TableCell sx={cell}>{item?.quantity}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* NOTES */}
      <Typography
        sx={{
          textAlign: "center",
          letterSpacing: "6px",
          fontWeight: 600,
          mt: 4,
          mb: 1,
        }}
      >
        ANY OTHER NOTES
      </Typography>

      <Box
        sx={{
          border: "1px solid black",
          height: "220px",
        }}
      />

      {/* SIGNATURE */}
      <Typography
        sx={{
          textAlign: "center",
          letterSpacing: "6px",
          fontWeight: 600,
          mt: 4,
          mb: 1,
        }}
      >
        CUSTOMER SIGNATURE
      </Typography>

      <Table
        sx={{
          border: "1px solid black",
          borderCollapse: "collapse",
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>Customer Signature:</TableCell>
            <TableCell sx={cell}>Staff Signature:</TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>Date:</TableCell>
            <TableCell sx={cell}>Date:</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default BoxCollection;

const cell = {
  border: "1px solid black",
  padding: "6px 8px",
  fontSize: "14px",
};
